<nb-card class="content-view">
  <nb-card-header>
    <div *ngIf="!loading && !exercise" class="text-heading">
      Chưa có bài tập
    </div>
    <div *ngIf="exercise" class="text-heading">
      {{ courseLecture.title }}
    </div>

    <button
      class="close"
      nbButton
      status="danger"
      size="small"
      (click)="close()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body *ngIf="exLoaded">
    <ngx-view-do-exercise
      [exercise]="exercise"
      (onMaxPercentage)="onMaxPercentage($event)"
    >
    </ngx-view-do-exercise>
  </nb-card-body>
</nb-card>
